
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 38 37","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#111","stroke-width":"2","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M4.273 35.964A3.273 3.273 0 011 32.69V1h10.636l3.273 4.91h17.182v3.928"}}),_c('path',{attrs:{"d":"M7.545 16.543V32.69a3.273 3.273 0 01-3.272 3.273h29.454A3.273 3.273 0 0037 32.69V16.543H7.545z"}})])])
          )
        }
      }
    